import { useNavigate } from "react-router-dom";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateMember } from "@factory/query/member.query";
import { MemberFormSchema } from "@factory/form/form.rule";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useTransactionStep } from "@domain/transaction/new-transaction/transaction-step.hook";

export function useNewMember() {
  // LOCAL DECLARATION
  const {
    stepperRef,
    parentMemberRef,
    parentFormData,
    childFormData,
    childFormRefs,
    childFormCount,
    handleParentForm,
    handleParentTrigger,
    handleChildFormSubmit,
    handleAddChildForm,
    handleChildTrigger,
    nextStepper
  } = useTransactionStep();
  const navigate = useNavigate();
  const { mapCreateMember } = useFormApiMapper();
  const { showSuccess } = useNotificationContext();

  // QUERIES
  const handleChildApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;
    const child = `${data.first_name} ${data.last_name}`;

    showSuccess(`${child} is created`);
  };
  const { mutate: addChildMember } = useQyCreateMember(handleChildApiSuccess);

  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;
    const parentCode = data.code;

    showSuccess(`${data.first_name} ${data.last_name} is created`);
    navigate(`../${parentCode}`);

    if (!parentCode) return;

    childFormData.forEach((item) => {
      const updatedForm = {
        ...item,
        isChild: true,
        parentCode,
      } as MemberFormSchema;
      const form = mapCreateMember(updatedForm);
      addChildMember(form);
    });
  };
  const { mutate: addMember, isLoading: isCreating } =
    useQyCreateMember(handleApiSuccess);

  const handleSaveMembers = () => {
    const parent = mapCreateMember(parentFormData as MemberFormSchema);
    addMember(parent);
  };

  return {
    stepperRef,
    parentMemberRef,
    parentFormData,
    childFormData,
    childFormRefs,
    childFormCount,
    isCreating,
    navigate,
    handleParentForm,
    handleParentTrigger,
    handleChildFormSubmit,
    handleAddChildForm,
    handleChildTrigger,
    handleSaveMembers,
    nextStepper
  };
}
